import { colorPalette } from '../../colorPalette';
/**
 * @param color string (hexa format)
 * @returns string
 * @description
 * This function is used to create a gradient circle url
 * @example
 * <CircularProgress sx={{ content: createGradientCircleURL('#ff0000') }} />
 * @example
 * <CircularProgress sx={{ content: createGradientCircleURL() }} />
 */
export function createGradientCircleURL(color) {
    const opacityPadding = 25;
    const defaultColor = colorPalette.red700;
    const hexColor = (color === null || color === void 0 ? void 0 : color.length) !== 7 || !color.startsWith('#') ? defaultColor : color;
    const r = parseInt(hexColor.substring(1, 3), 16);
    const g = parseInt(hexColor.substring(3, 5), 16);
    const b = parseInt(hexColor.substring(5, 7), 16);
    const stopColor1 = `rgba(${r}, ${g}, ${b}, 0)`;
    const stopColor2 = `rgba(${r - opacityPadding}, ${g}, ${b}, 0)`;
    const stopColor3 = `rgb(${r}, ${g}, ${b})`;
    return `\
      url('data:image/svg+xml;utf8,\
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="22 22 44 44">\
          <linearGradient id="gradient" x1="100%" y1="0%" x2="0%" y2="0%">\
            <stop offset="0%" stop-color="${stopColor1}" />\
            <stop offset="0.04%" stop-color="${stopColor2}" />\
            <stop offset="100%" stop-color="${stopColor3}" />\
          </linearGradient>\
          <circle cx="44" cy="44" r="20.2" fill="none" stroke-dasharray="80px 200px" stroke-dashoffset="0" stroke="url(%23gradient)" stroke-width="3.6px" stroke-linecap="round" />\
        </svg>')`;
}
